import { post } from './fetch';

const apiReportSystemError = async ( caption, error, dispatch ) => {
    await post( 'reportSystemError', 
        '/api/email/syserr', { caption, error }, null, dispatch
    );
}

export default apiReportSystemError;
